import { gql } from "apollo-boost";

export const GQL_GET_META_INFO = gql`
  query($ids: [String!]!, $userId: String) {
    getMetaInfo(ids: $ids) {
      fatherId
      myCommentTime(ownerId: $userId) {
        count
      }
      commentTime {
        count
      }
      liked(ownerId: $userId) {
        status
      }
      likedTime {
        count
      }
    }
  }
`;

export const GQL_GET_SINGLE_META_INFO = gql`
  query($id: String!, $userId: String, $skipComment: Boolean!) {
    getSingleMetaInfo(id: $id) {
      fatherId
      myCommentTime(ownerId: $userId) @skip(if: $skipComment) {
        count
      }
      commentTime @skip(if: $skipComment) {
        count
      }
      liked(ownerId: $userId) {
        status
      }
      likedTime {
        count
      }
    }
  }
`;

export const GQL_GET_COLLECTOR_COMMENT_TIME = gql`
  query($ids: [String!]!, $userId: String) {
    getMetaInfo(ids: $ids) {
      fatherId
      collectorCommentTime: myCommentTime(ownerId: $userId) {
        count
      }
    }
  }
`;

export const GQL_GET_SINGLE_LIKE_INFO = gql`
  query($fatherId: String!, $userId: String) {
    getSingleMetaInfo(id: $fatherId) {
      fatherId
      liked(ownerId: $userId) {
        status
      }
      likedTime {
        count
      }
    }
  }
`;
